// @ts-check

import { isNumeric, numberOrDefault } from '@/helpers/functional'

/** @param {import('vue-router').RouteLocation} to */
export const setupDatatableRoute = (to) => {
  const { limit, page } = to.query

  if (isNumeric(limit) && isNumeric(page)) {
    return true
  }

  return {
    path: to.path,
    query: {
      ...to.query,
      limit: numberOrDefault(limit, 10),
      page: numberOrDefault(page, 1)
    }
  }
}

export default {}
